import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../stores/Stores";
import { Select } from "@fluentui/react-components";
import { BuildingMultipleRegular } from "@fluentui/react-icons";
import Loader from "../shared/loader/Loader";
import styles from "./customerMeetings.module.scss";
import { BusinessLine } from "../shared/types/BusinessLine";
import { mapBusinessLineToName } from "./MeetingHelpers";
import RetailOrPrivateMeetingForm from "./forms/RetailOrPrivateMeetingForm";
import CorporateMeetingForm from "./forms/CorporateMeetingForm";
import { FormActionType } from "./forms/FormActionType";
import { useTranslation } from "../shared/translation/Translation";

interface CreateMeetingProps {
    onClose: () => void;
}

const CreateMeeting: React.FC<CreateMeetingProps> = observer((props: CreateMeetingProps) => {
    const { meetingStore, userStore } = useStore();
    const messages = useTranslation();

    const [businessLine, setBusinessLine] = useState<BusinessLine>();

    useEffect(() => {
        if (userStore.businessLines.length === 1) {
            setBusinessLine(userStore.businessLines[0]);
        }
    }, [userStore, setBusinessLine]);

    function renderForm(businessLine: BusinessLine) {
        switch (businessLine) {
            case BusinessLine.Private:
            case BusinessLine.Retail:
                return (
                    <RetailOrPrivateMeetingForm
                        formActionType={FormActionType.CreateMeeting}
                        businessLine={businessLine}
                        onClose={props.onClose}
                    />
                );
            case BusinessLine.Corporate:
                return (
                    <CorporateMeetingForm
                        formActionType={FormActionType.CreateMeeting}
                        businessLine={businessLine}
                        onClose={props.onClose}
                    />
                );
        }
    }

    function renderContent() {
        if (meetingStore.createMeetingRequestStatus.isPending) {
            return <Loader text={messages.createMeeting.adding} />;
        }

        return (
            <>
                <div className={styles.businessLineDropdownWrapper}>
                    <BuildingMultipleRegular className={styles.businessLineIcon} />
                    <Select
                        className={styles.businessLineDropdown}
                        disabled={userStore.businessLines.length <= 1}
                        value={businessLine !== undefined ? mapBusinessLineToName(messages, businessLine) : ""}
                        onChange={(_, data) => {
                            const idx = userStore.businessLines.findIndex(
                                (x) => mapBusinessLineToName(messages, x) === data.value
                            );
                            if (idx !== -1) setBusinessLine(userStore.businessLines[idx]);
                        }}
                    >
                        <option value="" disabled>
                            {messages.createMeeting.selectBusinessLinePlaceholder}
                        </option>
                        {userStore.businessLines.map((x, i) => (
                            <option key={i} value={mapBusinessLineToName(messages, x)}>
                                {mapBusinessLineToName(messages, x)}
                            </option>
                        ))}
                    </Select>
                </div>
                {userStore.businessLines.length < 1 && <p>{messages.createMeeting.noBusinessLineFound}</p>}
                {renderForm(businessLine!)}
            </>
        );
    }

    return <div className={styles.modalWrapper}>{renderContent()}</div>;
});

export default CreateMeeting;
